import React from "react"
import PropTypes from "prop-types"

import styles from "./breadCrumb.css"
import BreadCrumb from "./BreadCrumb"

const BreadCrumbWrapper = ({ steps, theme, children }) => {
  return (
    <div className={styles.container}>
      <div className={styles.breadcrumb}>
        <BreadCrumb steps={steps} theme={theme} />
      </div>
      <div>{children}</div>
    </div>
  )
}

BreadCrumbWrapper.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      route: PropTypes.string.isRequired,
    })
  ),
  theme: PropTypes.oneOf(["light", "dark"]),
  children: PropTypes.node,
}

export default BreadCrumbWrapper
